import YouTube, { Options as YouTubeOptions } from "react-youtube";
import YouTubeIcon from "@material-ui/icons/YouTube";
import { acceptCookieConsent } from "helpers";
import { useCookieConsent } from "hooks/useCookieConsent";
import { VIDEO_ID } from "config";
import ConsentOverlay from "components/ConsentOverlay";

interface GameVideoProps {
  onEnd?: () => void;
}

/** YouTube video player with cookie consent gate. */
export default function GameVideo({ onEnd }: GameVideoProps) {
  const hasConsent = useCookieConsent();

  if (!hasConsent) {
    return (
      <ConsentOverlay
        thumbnailUrl={`https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
        thumbnailAlt="Dev Concierge YouTube video thumbnail"
        message="To view this embedded video, please accept third-party cookies."
        watchUrl={`https://www.youtube.com/watch?v=${VIDEO_ID}`}
        watchLabel="Watch on YouTube"
        watchIcon={<YouTubeIcon fontSize="small" />}
        onAllow={acceptCookieConsent}
      />
    );
  }

  const opts = {
    width: "100%",
    host: "https://www.youtube-nocookie.com",
    playerVars: {
      autoplay: 1,
    },
  } as YouTubeOptions;

  return <YouTube videoId={VIDEO_ID} opts={opts} onEnd={onEnd} />;
}
